import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export default function UITooltipContent({
  className,
  children
}) {
  return /*#__PURE__*/_jsx("div", {
    className: classNames('private-tooltip__inner', className),
    role: "tooltip",
    children: children
  });
}
UITooltipContent.displayName = 'UITooltipContent';